import { useCallback } from 'react';
import { useAccount, useSignMessage as useSignMessageWagmi } from 'wagmi';

/* Hook */
export const useSignMessage = () => {
  const { address } = useAccount();
  const { signMessageAsync } = useSignMessageWagmi();

  /* Callbacks */
  const signMessage = useCallback(
    async (message: string): Promise<string> => {
      if (!address) {
        throw new Error('Smart account address not available');
      }

      try {
        const signature = await signMessageAsync({ message });
        return signature;
      } catch (error) {
        console.error('Error signing message:', error);
        throw error;
      }
    },
    [address, signMessageAsync],
  );

  /* Return */
  return {
    signMessage,
  };
};
